<video class="app-border w-100" *ngIf="url$ | async as url" controls>
  <source [src]="url" />
</video>
